import React, { useRef, useContext, useState } from "react";
import { defineMessages, useIntl, FormattedMessage } from "react-intl";
import { Form, RequiredValidator, Checkbox, Card, DocModal, } from "@lysaab/ui-2";
import { OnfidoContext } from "../../context/OnfidoContext";
import onfidoLogo from "./onfido-logo.svg";
import "./OnfidoIntroPage.scss";
import { IntroEmailCard } from "./IntroEmailCard";
import { Button } from "@lysaab/ui-2/components/buttons/Button";
import { LysaCountry } from "@lysaab/shared";
const messages = defineMessages({
    checkboxRequired: { id: "onfido.intro.gdpr_checkbox.required" },
    checkboxText: { id: "onfido.intro.gdpr_checkbox.text" },
    ingressMsg: { id: "onfido.intro.ingress" },
    modalAnnouncement: { id: "onfido.intro.gdpr_modal.announcement" },
    modalHeader: { id: "onfido.intro.gdpr_modal.header" },
    p1Msg: { id: "onfido.intro.p1" },
    p2Msg: { id: "onfido.intro.p2" },
});
const docList = {
    personalDataProcessing: {
        [LysaCountry.SWEDEN]: "legal/all/en/lysas-processing-of-personal-data-when-identifying-a-customers-identity.md",
        [LysaCountry.DENMARK]: "legal/all/en/lysas-processing-of-personal-data-when-identifying-a-customers-identity.md",
        [LysaCountry.FINLAND]: "legal/all/en/lysas-processing-of-personal-data-when-identifying-a-customers-identity.md",
        [LysaCountry.GERMANY]: "legal/de/de/lysas-processing-of-personal-data-when-identifying-a-customers-identity.md",
        [LysaCountry.SPAIN]: "legal/all/en/lysas-processing-of-personal-data-when-identifying-a-customers-identity.md",
    },
};
export const OnfidoIntroPage = ({ next, signupId, language, country, }) => {
    const intl = useIntl();
    const onfidoContext = useContext(OnfidoContext);
    const formRef = useRef();
    const submitRef = useRef(null);
    const [showDoc, setShowDoc] = useState(false);
    const nextPage = () => {
        if (formRef.current && formRef.current.isValid && next) {
            next();
        }
    };
    return (React.createElement("div", { className: "onfido-intro-page" },
        React.createElement(DocModal, { header: intl.formatMessage(messages.modalHeader), active: !!showDoc, onRequestClose: () => setShowDoc(false), docList: [docList.personalDataProcessing[country]], modalAnnouncement: intl.formatMessage(messages.modalAnnouncement) }),
        React.createElement("h2", null,
            React.createElement(FormattedMessage, { id: "onfido.intro.title" })),
        React.createElement(Card, null,
            React.createElement(Form, { onSubmit: nextPage, lysaFormRef: formRef },
                React.createElement("div", { style: {
                        display: "flex",
                        justifyContent: "center",
                        padding: "7px 0 4px 0",
                    } },
                    React.createElement("img", { src: onfidoLogo, className: "onfido-logo", alt: "Onfido logo" })),
                React.createElement("p", { style: { fontWeight: "bold" } }, intl.formatMessage(messages.ingressMsg)),
                React.createElement("p", null, intl.formatMessage(messages.p1Msg)),
                React.createElement("p", null, intl.formatMessage(messages.p2Msg, {
                    link: (chunks) => (React.createElement("button", { type: "button", className: "as-link", key: "element-key", onClick: () => setShowDoc((showDoc) => !showDoc) }, chunks)),
                })),
                React.createElement(Checkbox, { alternative: {
                        text: intl.formatMessage(messages.checkboxText),
                        value: true,
                    }, checked: onfidoContext.state.gdprCheck, onChange: () => {
                        onfidoContext.setState({
                            gdprCheck: !onfidoContext.state.gdprCheck,
                        });
                    }, validators: [
                        new RequiredValidator(intl.formatMessage(messages.checkboxRequired)),
                    ] }),
                React.createElement(Button, { type: "submit", className: "intro-hidden-submit", ref: submitRef, label: "Hidden submit button" }))),
        signupId && language && (React.createElement(IntroEmailCard, { signupId: signupId, language: language, country: country })),
        React.createElement(Button, { type: "button", block: true, onClick: () => { var _a; return (_a = submitRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, label: React.createElement(FormattedMessage, { id: "onfido.intro.next" }) })));
};
